import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_warning-circle",
  "use": "svg_warning-circle-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"svg_warning-circle\"><circle cx=\"7\" cy=\"7\" r=\"6\" stroke=\"currentColor\" stroke-width=\"2\" /><path d=\"M7 4v3\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" /><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7 9a1 1 0 1 1 0 2 1 1 0 0 1 0-2Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol